module.exports = __webpack_public_path__ + "static/media/outros.e99e0996.jpeg";